import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]
  // Minimum characters before a typed search is sent. 0 keeps the original
  // behaviour. An empty box always submits so the default list comes back.
  static values = { minChars: { type: Number, default: 0 } }

  connect() {
    this.timeout = null
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  search() {
    clearTimeout(this.timeout)
    const length = this.inputTarget.value.trim().length
    if (length > 0 && length < this.minCharsValue) return

    this.timeout = setTimeout(() => {
      this.inputTarget.form.requestSubmit()
    }, 300)
  }

  scanned(event) {
    this.inputTarget.value = event.detail.barcode
    this.inputTarget.form.requestSubmit()
  }
}
